<ion-header class="mobile-header">
  <ion-toolbar brandingBackground="primaryColor">
    <ion-buttons slot="start">
      <ion-button size="small" color="white" fill="clear" (click)="goBack()">
        <ion-icon name="close-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title (click)="showProgramOptions()">
      <div class="topDvCaption" [class.split-header]="workoutProgramKind === 'split'">
        <div class="title">
          {{activeWorkoutProgram.title ? activeWorkoutProgram.title : (workoutProgramKind === 'split' ? 'New Muscle Split' : 'New Training Program')}} 
          <ion-icon [name]="workoutProgramKind === 'split' ? 'body-outline' : 'create-outline'"></ion-icon>
        </div>
        <div class="subtitle">
          {{activeWorkoutProgram.startDate | date}}
          <span *ngIf="activeWorkoutProgram.endDate">
            - {{activeWorkoutProgram.endDate | date}}
          </span>
          <ion-icon name="calendar-outline"></ion-icon>
        </div>
      </div>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button size="small" color="white" shape="round" (click)="showNotes()" *ngIf="mode === 'program'">
        <ion-icon slot="icon-only" name="list-outline"></ion-icon>
      </ion-button>
      <ion-button size="small" color="white" shape="round" [matMenuTriggerFor]="workoutMobileChangesMenu" *ngIf="(versionHistory?.length > 1 || hasDraft) && mode === 'program'">
        <ion-icon slot="icon-only" name="arrow-undo-outline"></ion-icon>
      </ion-button>
      <ion-button color="success" size="small" fill="solid" shape="round" (click)="publishWorkoutProgram()">
        {{'general.publish' | translate}}
      </ion-button>
    </ion-buttons>
    <mat-menu #workoutMobileChangesMenu="matMenu" yPosition="below">
      <button mat-menu-item type="button" (click)="undoRevision()" *ngIf="versionHistory?.length > 1">{{'general.undo' | translate}}</button>
      <button mat-menu-item type="button" (click)="revertDraft()" *ngIf="hasDraft">{{'general.revert' | translate}}</button>
    </mat-menu>
  </ion-toolbar>

  <ion-toolbar class="web-header active-plan" *ngIf="mode === 'program' && activeWorkoutProgram?.workouts?.length">
    <div class="plan-wrapper">
      <div class="plan-controls">
        <div class="plan-dropdown">
          <div class="plan-heading">{{'general.day' | translate}} {{(activeWorkoutIndex || 0) + 1}} / {{activeWorkoutProgram?.workouts?.length || 0}}</div>
          <button class="plan-dropdown-btn" type="button" (click)="openWorkoutDrawer()">
            <div class="plan-dropdown-title">
              {{ activeWorkoutProgram?.workouts?.[activeWorkoutIndex]?.title || ((('general.day' | translate) + ' ' + ((activeWorkoutIndex || 0) + 1)))}}
            </div>
            <ion-icon [name]="isWorkoutDrawerOpen ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
          </button>
        </div>
      </div>
    </div>
  </ion-toolbar>
  <ion-toolbar class="web-header plan-inline-toolbar" [class.is-open]="isWorkoutDrawerOpen" *ngIf="mode === 'program' && activeWorkoutProgram?.workouts?.length">
    <div class="active-plan-inline-panel" *ngIf="isWorkoutDrawerOpen">
      <div class="active-plan-popover" cdkDropList [cdkDropListData]="activeWorkoutProgram.workouts" (cdkDropListDropped)="drop($event)">
        <div
          class="popover-option"
          cdkDrag
          *ngFor="let workout of activeWorkoutProgram.workouts; let i = index"
          [class.active]="i === activeWorkoutIndex"
          (click)="onWorkoutSelected(i)">
          <span class="drag-handle" cdkDragHandle>
            <ion-icon name="reorder-two-outline"></ion-icon>
          </span>
          <div class="option-content">
            <div class="option-title">{{workout?.title || ((('general.day' | translate) + ' ' + (i + 1)) )}}</div>
          </div>
          <div class="option-actions">
            <span *ngIf="i === activeWorkoutIndex" class="option-check-circle">
              <ion-icon class="option-check" name="checkmark-outline"></ion-icon>
            </span>
            <button
              type="button"
              class="option-menu-btn"
              mat-icon-button
              stop-propagation
              [matMenuTriggerFor]="workoutDrawerOptionsMenu">
              <ion-icon name="ellipsis-vertical-outline"></ion-icon>
            </button>
            <mat-menu #workoutDrawerOptionsMenu="matMenu" yPosition="below">
              <button mat-menu-item (click)="editWorkoutFromDrawer(i)" *ngIf="workout?.type !== 'rest'">{{'general.editTitle' | translate}}</button>
              <button mat-menu-item (click)="duplicateWorkoutFromDrawer(i)" *ngIf="mode === 'program'">{{(workout?.type === 'rest' ? 'general.duplicateDay' : 'general.duplicateWorkout') | translate}}</button>
              <button mat-menu-item (click)="saveWorkoutToLibraryFromDrawer(i)" *ngIf="mode === 'program' && workoutProgramKind !== 'split' && workout?.type !== 'rest'">{{'general.saveToLibrary' | translate}}</button>
              <button mat-menu-item (click)="deleteWorkoutFromDrawer(i)">{{(workout?.type === 'rest' ? 'general.deleteDay' : 'general.deleteWorkout') | translate}}</button>
            </mat-menu>
          </div>
        </div>
        <div class="ion-text-center ion-padding">
          <ion-button
            size="small"
            color="secondary"
            fill="solid"
            shape="round"
            [matMenuTriggerFor]="addWorkoutDrawerMenu">
            <ion-icon slot="start" name="add-outline"></ion-icon>
            <span>{{'general.day' | translate}}</span>
          </ion-button>
          <mat-menu #addWorkoutDrawerMenu="matMenu">
            <button mat-menu-item (click)="newWorkout()">{{'general.blankWorkout' | translate}}</button>
            <button mat-menu-item (click)="selectWorkout()" *ngIf="workoutProgramKind !== 'split'">{{'general.savedWorkout' | translate}}</button>
            <mat-divider></mat-divider>
            <button mat-menu-item (click)="newRestDay()">{{'general.restDay' | translate}}</button>
          </mat-menu>
        </div>
      </div>
    </div>
  </ion-toolbar>

</ion-header>

<ng-container *ngIf="!comparePaneEmbedded; else embeddedWorkoutBuilderContent">
  <ion-content class="ion-padding">
    <ng-container *ngTemplateOutlet="workoutBuilderContent"></ng-container>
  </ion-content>
</ng-container>
<ng-template #embeddedWorkoutBuilderContent>
  <div class="ion-padding compare-pane-embedded-content">
    <ng-container *ngTemplateOutlet="workoutBuilderContent"></ng-container>
  </div>
</ng-template>

<ng-template #workoutBuilderContent>
  <div class="content">

    <div class="desktop-sticky-shell ion-hide-lg-down">
      <!-- UPDATED WEB HEADER -->
      <div class="web-header">
        <div class="left">
          <div class="backBtnTopPanel">
            <div>
              <h2 class="title" (click)="showProgramOptions()" [class.split-title]="workoutProgramKind === 'split'">
                {{activeWorkoutProgram.title ? activeWorkoutProgram.title : (workoutProgramKind === 'split' ? 'New Muscle Split' : 'New Training Program')}}
              </h2>

              <div class="date-row" *ngIf="mode === 'program'">
                <span class="date" (click)="editDate($event, 'startDate')">
                  {{ activeWorkoutProgram.startDate | date:'MMM d, y' }}
                </span>

                <span class="separator">–</span>

                <span class="date"
                      [class.placeholder]="!activeWorkoutProgram.endDate"
                      (click)="editDate($event, 'endDate')">
                  <ng-container *ngIf="activeWorkoutProgram.endDate; else addEndDate">
                    {{ activeWorkoutProgram.endDate | date:'MMM d, y' }}
                  </ng-container>
                  <ng-template #addEndDate>
                    {{'mealPlanBuilder.addEndDate' | translate}}
                  </ng-template>
                </span>

                <ion-icon name="calendar-outline"></ion-icon>
              </div>
            </div>

          </div>
        </div>

        <div class="right">
          <ion-button size="small" class="notes-btn" (click)="undoRevision()" *ngIf="versionHistory?.length > 1">
            <ion-icon name="arrow-undo-outline"></ion-icon>
            <span>{{'general.undo' | translate}}</span>
          </ion-button>
          <ion-button size="small" class="notes-btn" (click)="revertDraft()" *ngIf="hasDraft">
            <ion-icon name="arrow-undo-outline"></ion-icon>
            <span>{{'general.revert' | translate}}</span>
          </ion-button>
          <ion-button size="small" class="notes-btn" (click)="showNotes()" *ngIf="mode === 'program'">
            <ion-icon name="chatbubble-outline"></ion-icon>
            <span>{{'general.notes' | translate}}</span>
          </ion-button>
          <ion-button size="small" color="success" (click)="publishWorkoutProgram()">
            <ion-icon name="save-outline"></ion-icon>
            {{'general.publish' | translate}}
          </ion-button>
          <ion-button size="small" class="settings-btn" fill="clear" (click)="goBack()">
            <ion-icon name="close-outline" slot="icon-only"></ion-icon>
          </ion-button>
        </div>
      </div>
    </div>
    <!-- END UPDATED WEB HEADER -->

    <div class="navDiv m-hide" *ngIf="(mode === 'program' || mode === 'workout') && activeWorkoutProgram?.workouts?.length"> 
      <div class="etTabsWrapper">
        <nav class="et-tabs" cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="drop($event)" appHorizontalScroll>
          <a class="tab" cdkDrag [cdkDragDisabled]="activeWorkoutIndex !== i"
             *ngFor="let workout of activeWorkoutProgram.workouts; let i = index;"
             (click)="setActiveWorkout(i)"
             [class.active]="activeWorkoutIndex === i"> 
            {{workout.type === 'rest'? ('general.rest' | translate) : workout.title}}
            <span class="action" *ngIf="activeWorkoutIndex === i" mat-button [matMenuTriggerFor]="menu">
              <ion-icon name="ellipsis-vertical-outline"></ion-icon>
            </span>
            <mat-menu #menu="matMenu" yPosition="below">
              <button mat-menu-item (click)="editWorkoutTitle()" *ngIf="activeWorkout.type !== 'rest'">
                {{'general.editTitle' | translate}}
              </button>
              <button mat-menu-item (click)="duplicateWorkout(i)" *ngIf="mode === 'program'">
                {{(activeWorkout.type === 'rest'? 'general.duplicateDay' : 'general.duplicateWorkout') | translate}}
              </button>
              <button mat-menu-item (click)="saveWorkoutToLibrary()"
                      *ngIf="mode === 'program' && workoutProgramKind !== 'split' && activeWorkout?.type !== 'rest'">
                {{'general.saveToLibrary' | translate}}
              </button>
              <button mat-menu-item (click)="deleteWorkout()">
                {{(activeWorkout.type === 'rest'? 'general.deleteDay' : 'general.deleteWorkout') | translate}}
              </button>
            </mat-menu>
            <span class="moveDiv" *ngIf="activeWorkoutIndex === i && mode === 'program'" cdkDragHandle>
              <ion-icon name="swap-horizontal-outline"></ion-icon>
            </span>
          </a>

          <ion-button size="small" color="secondary" [matMenuTriggerFor]="menu" *ngIf="mode === 'program'">
            <ion-icon size="small" name="add-outline"></ion-icon>
            {{'general.day' | translate}}
          </ion-button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="newWorkout()">
              {{'general.blankWorkout' | translate}}
            </button>
            <button mat-menu-item (click)="selectWorkout()" *ngIf="workoutProgramKind !== 'split'">
              {{'general.savedWorkout' | translate}}
            </button>       
            <mat-divider></mat-divider>
            <button mat-menu-item (click)="newRestDay()">
              {{'general.restDay' | translate}}
            </button>         
          </mat-menu>
        </nav>
      </div>
    </div>

    <ion-grid *ngIf="configSet && activeWorkoutProgram?.workouts?.length">
      <!-- Volume -->
      <ion-row class="workout-details" *ngIf="activeWorkout.type !== 'rest'">
        <ion-col>
          <div class="gutter">
            <table>
              <tr>
                <td>
                  {{'general.totalVolume' | translate}}: {{getActiveVolume()}} sets
                </td>
              </tr>
            </table>
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <div class="switchTabsDv clientFeaturePanelDetail">
            <div class="switchTabsInner" *ngIf="activeWorkout">
              <div class="table3td">

                <!-- Rest Notes -->
                <div class="restContainer" *ngIf="activeWorkout.type === 'rest'">
                  <ion-label>
                    {{'general.restDayNotes' | translate}}
                  </ion-label>
                  <ion-textarea 
                    class="formControl" 
                    name="workoutNotes" 
                    [(ngModel)]="activeWorkout.notes"
                    [autoGrow]="true"
                    [debounce]="800"
                    (ionInput)="saveWorkoutProgram()"
                  >
                  </ion-textarea>
                </div>

                <!-- Split day: primary + secondary muscles -->
                <div class="formStyle2 split-day-editor" *ngIf="workoutProgramKind === 'split' && activeWorkout.type === 'workout'">
                  <ion-row class="split-editor-layout">
                    <ion-col size="12" class="split-primary-col split-form-col">
                      <div class="split-left">
                        <div class="split-section">
                          <div class="split-label-row">
                            <h6 class="split-section-title">{{'workoutProgramBuilder.primaryMuscle' | translate}}</h6>
                          </div>
                          <ion-row class="split-row">
                            <ion-col size="12" size-md="4">
                              <ion-item class="ion-no-padding">
                                <ion-label position="stacked">{{'workoutProgramBuilder.muscleGroup' | translate}}</ion-label>
                                <mat-select class="formControl" [(ngModel)]="activeWorkout.primaryMuscle" (selectionChange)="saveWorkoutProgram()" name="primaryMuscle" [placeholder]="'workoutProgramBuilder.muscleGroup' | translate">
                                  <mat-option *ngFor="let m of muscleGroups" [value]="m.value">{{m.name || m.value}}</mat-option>
                                </mat-select>
                              </ion-item>
                            </ion-col>
                            <ion-col size="12" size-md="3">
                              <ion-item class="ion-no-padding">
                                <ion-label position="stacked">{{'workoutProgramBuilder.targetSets' | translate}}</ion-label>
                                <ion-input class="formControl" type="number" inputmode="numeric" min="0" [(ngModel)]="activeWorkout.primarySets" (ionInput)="saveWorkoutProgram()" name="primarySets"></ion-input>
                              </ion-item>
                            </ion-col>
                            <ion-col size="12" size-md="1" class="split-action-col"></ion-col>
                          </ion-row>
                        </div>
                        <div class="split-section">
                          <div class="split-label-row">
                            <h6 class="split-section-title">{{'workoutProgramBuilder.secondaryMuscles' | translate}}</h6>
                          </div>
                          <div class="secondary-list" *ngIf="activeWorkout.secondaryMuscles?.length">
                            <ion-row *ngFor="let sec of activeWorkout.secondaryMuscles; let si = index" class="secondary-row">
                              <ion-col size="12" size-md="4">
                                <ion-item class="ion-no-padding">
                                  <ion-label position="stacked">{{'workoutProgramBuilder.muscleGroup' | translate}}</ion-label>
                                  <mat-select class="formControl" [(ngModel)]="sec.muscle" (selectionChange)="saveWorkoutProgram()" [name]="'secMuscle' + si" [placeholder]="'workoutProgramBuilder.muscleGroup' | translate">
                                    <mat-option *ngFor="let m of muscleGroups" [value]="m.value">{{m.name || m.value}}</mat-option>
                                  </mat-select>
                                </ion-item>
                              </ion-col>
                              <ion-col size="12" size-md="3">
                                <ion-item class="ion-no-padding">
                                  <ion-label position="stacked">{{'workoutProgramBuilder.targetSets' | translate}}</ion-label>
                                  <ion-input class="formControl" type="number" inputmode="numeric" min="0" [(ngModel)]="sec.sets" (ionInput)="saveWorkoutProgram()" [name]="'secSets' + si"></ion-input>
                                </ion-item>
                              </ion-col>
                              <ion-col size="12" size-md="1" class="secondary-remove-col">
                                <ion-button fill="clear" size="small" (click)="removeSecondaryMuscle(si)">
                                  <ion-icon name="trash-outline"></ion-icon>
                                </ion-button>
                              </ion-col>
                            </ion-row>
                          </div>
                          <div class="secondary-add-row">
                            <ion-button size="small" color="secondary" (click)="addSecondaryMuscle()">
                              {{'workoutProgramBuilder.addSecondary' | translate}}
                            </ion-button>
                          </div>
                        </div>
                      </div>
                    </ion-col>
                    <ion-col size="12" class="split-chart-col">
                      <div class="split-chart-section">
                        <h6 class="split-section-title split-chart-title">{{'general.volumeByMuscleGroup' | translate}}</h6>
                        <div class="split-color-legend" *ngIf="splitEditorLegendItems.length">
                          <div class="split-legend-item" *ngFor="let item of splitEditorLegendItems">
                            <span class="split-legend-dot" [style.background]="item.color"></span>
                            <div class="split-legend-text">
                              <span class="split-legend-label">{{ item.label }}</span>
                              <span class="split-legend-meta">{{ item.sets }} sets</span>
                            </div>
                          </div>
                        </div>
                        <div class="split-chart-wrap">
                          <canvas baseChart
                            *ngIf="splitEditorHasChartData"
                            [data]="splitEditorChartData"
                            [type]="splitEditorChartType"
                            [options]="splitEditorChartOptions"
                            [legend]="false">
                          </canvas>
                        </div>
                      </div>
                    </ion-col>
                  </ion-row>
                </div>

                <!-- Split Workout Notes -->
                <div class="restContainer" *ngIf="workoutProgramKind === 'split' && activeWorkout.type !== 'rest'">
                  <ion-label>
                    {{'general.notes' | translate}}
                  </ion-label>
                  <ion-textarea 
                    class="formControl" 
                    name="workoutNotes" 
                    [(ngModel)]="activeWorkout.notes"
                    [autoGrow]="true"
                    [debounce]="800"
                    (ionInput)="saveWorkoutProgram()"
                  >
                  </ion-textarea>
                </div>

                <!-- Workout Sets (exercise-based program only) -->
                <ion-reorder-group (ionItemReorder)="reorderSet($event)" disabled="false" *ngIf="workoutProgramKind !== 'split'">
                  <div class="boxShadowDiv" *ngFor="let set of activeWorkout.sets; let i=index">
                    <div class="set-header">
                      <span class="set-title">{{'general.exercise' | translate}}: {{i + 1}}</span>
                      <div class="set-actions">
                        <button type="button" class="m-hide" [matMenuTriggerFor]="setCopyMenu">
                          <ion-icon size="small" name="copy-outline"></ion-icon>
                        </button>
                        <mat-menu #setCopyMenu="matMenu" yPosition="below">
                          <button mat-menu-item (click)="duplicateSet(set, i)">
                            {{'general.duplicateExercise' | translate}}
                          </button>
                          <button mat-menu-item (click)="copySetToWorkout(set)">
                            {{'general.copytoWorkout' | translate}}
                          </button>
                        </mat-menu>
                        <button class="m-hide" (click)="removeSet(set, i)">
                          <ion-icon size="small" name="trash-outline"></ion-icon>
                        </button>
                        <ion-reorder>
                          <button type="button">
                            <ion-icon size="small" name="swap-vertical-outline"></ion-icon>
                          </button>
                        </ion-reorder>
                        <button type="button" class="d-hide" [matMenuTriggerFor]="setActionsMobileMenu">
                          <ion-icon size="small" name="ellipsis-vertical-outline"></ion-icon>
                        </button>
                        <mat-menu #setActionsMobileMenu="matMenu" yPosition="below">
                          <button mat-menu-item (click)="duplicateSet(set, i)">
                            {{'general.duplicateExercise' | translate}}
                          </button>
                          <button mat-menu-item (click)="copySetToWorkout(set)">
                            {{'general.copytoWorkout' | translate}}
                          </button>
                          <button mat-menu-item (click)="removeSet(set, i)">
                            {{'general.delete' | translate}}
                          </button>
                        </mat-menu>
                      </div>
                    </div>
  
                    <div class="boxShadowDiv__inner" *ngFor="let exercise of set.exercises; let j=index">
                      <app-exercise-set-card
                        [set]="set"
                        [exerciseIndex]="j"
                        mode="edit"
                        [userId]="programUserId"
                        [type]="mode"
                        [userEquipmentList]="equipmentList"
                        (onSetChanged)="saveWorkoutProgram()">
                      </app-exercise-set-card>
                    </div>
                  </div>  
                </ion-reorder-group>

                <ion-button size="small" color="secondary" (click)="addExercises()"
                  *ngIf="activeWorkout.sets && activeWorkout.sets.length > 0" class="addCommonBtn">
                  <ion-icon name="add-outline"></ion-icon>
                  {{'general.exercise' | translate}}
                </ion-button>
              </div>

              <!-- No exercise Panel Start (exercise-based program only) -->
              <div class="noEexcercisePanel"
                   *ngIf="workoutProgramKind !== 'split' && activeWorkout.type !== 'rest' && (!activeWorkout.sets || activeWorkout.sets.length === 0)">
                <div class="noEexcercisePanel__img">
                  <img src="../../../../assets/imgs/my-program.png" alt="workout" />
                </div>
                <ion-button color="secondary" (click)="addExercises()"
                  *ngIf="activeWorkoutProgram.workouts" class="addCommonBtn">
                  <ion-icon name="add-outline"></ion-icon>
                  {{'general.exercise' | translate}}
                </ion-button>
              </div>
              <!-- No excercise Panel End -->

            </div>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>

    <!-- No Workouts Panel Start -->
    <div class="noEexcercisePanel" *ngIf="!activeWorkoutProgram?.workouts?.length">
      <div class="noEexcercisePanel__img">
        <img src="../../../../assets/imgs/my-program.png" alt="workout" />
      </div>
      <h3>{{'workoutProgramBuilder.addWorkout' | translate}}</h3>
      <div class="actions">
        <ion-button size="small" color="primary" class="addCommonBtn" (click)="newWorkout()">
          <ion-icon name="add-outline"></ion-icon>
          {{'workoutProgramBuilder.newWorkout' | translate}}
        </ion-button>
        <ion-button size="small" color="primary" class="addCommonBtn" (click)="selectWorkout()" *ngIf="workoutProgramKind !== 'split'">
          <ion-icon name="add-outline"></ion-icon>
          {{'workoutProgramBuilder.fromLibrary' | translate}}
        </ion-button>
      </div>
    </div>
    <!-- No Supplements Panel End -->
  </div>
</ng-template>
